import { render, staticRenderFns } from "./LoginOtp.vue?vue&type=template&id=5338cf36&scoped=true"
import script from "./LoginOtp.vue?vue&type=script&lang=js"
export * from "./LoginOtp.vue?vue&type=script&lang=js"
import style0 from "./LoginOtp.vue?vue&type=style&index=0&id=5338cf36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338cf36",
  null
  
)

export default component.exports